export default "__VITE_ASSET__pUWkrL34__"